var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 37,
    viewBox: "0 0 41 37",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.81277 0.333008H38.4309C38.9557 0.333008 39.459 0.544212 39.8301 0.920157C40.2012 1.2961 40.4097 1.80599 40.4097 2.33766V34.4121C40.4097 34.9438 40.2012 35.4536 39.8301 35.8296C39.459 36.2055 38.9557 36.4167 38.4309 36.4167H2.81277C2.28796 36.4167 1.78465 36.2055 1.41356 35.8296C1.04246 35.4536 0.833984 34.9438 0.833984 34.4121V2.33766C0.833984 1.80599 1.04246 1.2961 1.41356 0.920157C1.78465 0.544212 2.28796 0.333008 2.81277 0.333008ZM20.7406 17.7394L8.05259 6.82407L5.49007 9.87916L20.7663 23.0197L35.7675 9.86914L33.1792 6.8361L20.7406 17.7394Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.af118724d26828cb2a8e13412adc080d.svg";
export { ForwardRef as ReactComponent };